export default __webpack_public_path__ + "static/media/orange_mark_icon.e7253c52.svg";